import { Component, ChangeDetectionStrategy, HostListener, ViewChild, ElementRef, inject } from '@angular/core';
import { ReaderStore } from '../../reader/state';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'rdrx-quick-annotation',
  templateUrl: './quick-annotation.component.html',
  styleUrls: ['./quick-annotation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickAnnotationComponent {
  @ViewChild('infoBtn', { static: false }) infoBtn!: ElementRef<HTMLButtonElement>;

  readerStore = inject(ReaderStore);
  readonly quickAnnotationEnabled$ = this.readerStore.quickAnnotationEnabled$;
  isPopoverOpen = false;

  constructor(
    private readonly liveAnnouncer: LiveAnnouncer,
    private readonly translate: TranslateService,
  ) {}

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: MouseEvent): void {
    if (this.isPopoverOpen) {
      this.isPopoverOpen = false;
    }
  }

  toggleQuickAnnotation(): void {
    this.readerStore.toggleQuickAnnotationEnabled();
  }

  togglePopover(event: MouseEvent): void {
    event.stopPropagation();
    this.isPopoverOpen = !this.isPopoverOpen;

    if (this.isPopoverOpen) {
      setTimeout(() => {
        (
          document.querySelector('#quick-annotation-description') as HTMLElement
        )?.focus();
      }, 400);
    }
  }

  onCloseKeydown(event: KeyboardEvent): void {
    if (event.key === 'Tab') {
      this.isPopoverOpen = false;
      event.stopPropagation();
    } else if (event.key === 'Escape') {
      if (this.isPopoverOpen) {
        this.isPopoverOpen = false;
        this.infoBtn.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }
}
